// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Spinner } from '@lmc/ui-kit'
import React, { Component } from 'react'

class LoadingScreen extends Component {
  render() {
    return (
      <div style={styles.container}>
        <Spinner size="large" />
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    paddingTop: 100,
    color: colors.darkgrey
  }
}

export default LoadingScreen
